import a from "./index982.js";
function e(t) {
  return a(this.__data__, t) > -1;
}
export {
  e as default
};
